export const tableOption = {
  border: true,
  index: false,
  menuWidth: 450,
  dialogWidth: '460px',
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  column: [
    {
      label: 'ID',
      prop: 'id',
      addDisabled: true,
      editDisabled: true,
      addVisdiplay: false,
      width: 150,
      span: 24,
    },
    {
      label: '标签类型',
      prop: 'tagTypeName',
      width: 500,
      maxlength:40,
      showWordLimit: true,
      span: 24,
      rules: [{
        required: true,
        message: "请输入标签类型",
        trigger: "blur"
      }]
    },
  ]
}

export const tableDictItemOption = {
  page: false,
  border: true,
  stripe: true,
  align: 'center',
  menuAlign: 'center',
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [
    {
      label: 'ID',
      prop: 'id',
      addDisabled: true,
      editDisabled: true,
      addVisdiplay: false,
      width: 150
    },
    {
      label: '标签',
      prop: 'name',
      width: 360,
      maxlength:500,
      search: false,
      showWordLimit: true,
      rules: [{
        required: true,
        message: "请输入标签",
        trigger: "blur"
      }]
    },
    {
      label: '来源',
      prop: 'source',
      addDisabled: true,
      editDisabled: true,
      addVisdiplay: false,
      width: 150
    },
    {
      label: '编码',
      prop: 'tagCode',
      width: 150,
      rules: [{
        message: "不超过30个字符",
        max: 30,
        trigger: "blur",
      }, {
        message: "请输入以字母开头的由数字或字母组成的字符",
        pattern: /(^[a-zA-Z][0-9A-Za-z]*$)|(^[a-zA-Z]*$)/,
        trigger: "blur",
      }]
    },
    {
      label: '排序',
      prop: 'sort',
      sortable: true,
      formsolt: true,
      width: 150
    },
    {
      label: '状态',
      prop: 'statusText',
      addDisabled: true,
      editDisabled: true,
      addVisdiplay: false,
      width: 150
    },
  ]
}

export const tableDictItemTopicOption = {
  page: false,
  border: true,
  stripe: true,
  align: 'center',
  menuAlign: 'center',
  delBtn: false,
  editBtn: false,
  refreshBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [
    {
      label: '话题名称',
      prop: 'name',
      maxlength: 45,
      addDisabled: true,
      addVisdiplay: false,
      showWordLimit: true,
      rules: [{
        required: true,
        message: "请输入话题名称",
        trigger: "blur"
      }]
    },
    {
      label: '话题名称（英文）',
      prop: 'nameEn',
      maxlength: 45,
      addDisabled: true,
      addVisdiplay: false,
      showWordLimit: true,
      rules: [{
        required: true,
        message: "请输入话题名称（英文）",
        trigger: "blur"
      }],
      width: 150
    },
    {
      label: '状态',
      prop: 'show',
      search: false,
      showWordLimit: true,
      editDisabled: true,
    },
    {
      label: '创建者',
      prop: 'creator',
      editDisabled: true,
    },
    // {
    //   label: '是否热门',
    //   prop: 'hot',
    //   editDisabled: true,
    // },
    // {
    //   label: '排序',
    //   prop: 'sort',
    //   editVisdiplay: false,
    //   sortable: true,
    //   solt: true,
    //   rules: [{
    //     message: "请输入正整数的数字字符",
    //     pattern: /(^[0-9]*$)/,
    //     trigger: "blur",
    //   }, {
    //     message: "不能超过8个字符",
    //     max: 8,
    //     trigger: "blur",
    //   }]
    // },
    // {
    //   label: '话题类型',
    //   prop: 'topicType',
    //   editDisabled: false,
    //   type: 'select',
    //   dicData: [
    //     { value: 0, label: '公开' },
    //     { value: 1, label: '官方' },
    //   ],
    //   rules: [{
    //     required: true,
    //     message: "请选择话题类型",
    //     trigger: "change"
    //   }]
    // },
  ]
}

export const tableDictItemClassificationOption = {
  page: false,
  border: true,
  stripe: true,
  align: 'center',
  menuAlign: 'center',
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  column: [
    {
      label: '分类名称',
      prop: 'name',
      addDisabled: true,
      addVisdiplay: false,
      maxlength: 45,
      showWordLimit: true,
      rules: [{
          required: true,
          message: "请输入分类名称",
          trigger: "blur"
      }]
    },
    {
      label: '分类名称（英文）',
      prop: 'nameEn',
      addDisabled: true,
      addVisdiplay: false,
      maxlength: 45,
      showWordLimit: true,
      rules: [{
          required: true,
          message: "请输入分类名称（英文）",
          trigger: "blur"
      }]
    },
    {
      label: '创建者',
      prop: 'creator',
      width: 200,
      editDisabled: true,
    },
    {
      label: '显示在精彩分享页',
      prop: 'status',
      addDisabled: true,
      type: 'select',
      dicData: [{
        label: '是',
        value: 1
      }, {
        label: '否',
        value: 2
      }]
    },
    {
      label: '排序',
      prop: 'sort',
      sortable: true,
      rules: [{
        message: "请输入正整数(不超过8位)",
        pattern: /^[0-9]{1,8}$/,
        trigger: "blur",
      }],
    },
  ]
}

export const tableTagRelationOption = {
  border: true,
  index: false,
  width: 500,
  menuWidth: 250,
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  columnBtn: false,
  searchBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  searchFilterable: true,
  column: [
    {
      label: 'ParentId',
      prop: 'tagId',
      hide: true,
      addDisplay: false,
      addDisabled: true
    },
    {
      label: 'ID',
      prop: 'relatedId',
      addDisabled: true,
      addDisplay: false,
      width: 150
    },
    {
      label: '标签ID',
      prop: 'id',
      addDisabled: true,
      editDisabled: true,
      width: 150
    },
    {
      label: '标签类型',
      prop: 'typeName',
      slot: true,
      type: 'select',
      search: false,
      searchslot: true,
      width: 150
    },
    {
      label: '标签',
      prop: 'name',
      width: 290,
      maxlength:40,
      search: false,
      showWordLimit:true,
      slot:true,
      type:'select',
      multiple: true,
    },
    {
      label: '排序',
      prop: 'sort',
      sortable: true,
      width: 150
    }
  ]
}

export const tableTagRelationTopicOption = {
  border: true,
  index: false,
  width: 500,
  menuWidth: 250,
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  columnBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  searchBtn: false,
  searchFilterable: false,
  column: [
    {
      label: 'ParentId',
      prop: 'tagId',
      hide: true,
      addDisplay: false,
      addDisabled: true
    },
    {
      label: 'ID',
      prop: 'relatedId',
      addDisabled: true,
      addDisplay: false,
      width: 150
    },
    {
      label: '话题ID',
      prop: 'id',
      addDisabled: true,
      editDisabled: true,
      width: 150
    },
    {
      label: '话题',
      prop: 'name',
      width: 200,
      maxlength: 40,
      search: false,
      showWordLimit: true,
      slot: true,
      type: 'select',
      multiple: true,
    },
    {
      label: '话题（英文）',
      prop: 'nameEn',
      width: 200,
      maxlength: 40,
      search: false,
      showWordLimit: true,
      slot: true,
      type: 'select',
      multiple: true,
    },
    {
      label: '排序',
      prop: 'sort',
      sortable: true,
      width: 150
    }
  ]
}

export const statusOptions = [
  { value: 1, label: '上架' },
  { value: 2, label: '下架' },
]

export const hotOptions = [
  { value: true, label: '是' },
  { value: false, label: '否' },
]

export const topicTypeOptions = [
  { value: 0, label: '公开' },
  { value: 1, label: '官方' },
]


